function criaMascara(s,r){var t=s.value,u="",a=0,b=0,e="",l=!0;for(i=0;i<r.length;i++)"#"!=r.substr(i,1)&&(t=t.replace(r.substr(i,1),""));for(i=0;i<t.length;i++)isNaN(parseFloat(t.substr(i,1)))||(u+=t.substr(i,1));for(i=0;i<r.length;i++)"#"==r.substr(i,1)?""!=u.substr(a,1)?(e+=u.substr(a,1),a++,b++):l=!1:l&&""!=u.substr(a,1)&&(e+=r.substr(b,1),b++);s.value=e}

$(document).ready(function (){
  if ($('#recaptchaResponse').length > 0) {
    grecaptcha.ready(function() {
        grecaptcha.execute('6LdJC3IaAAAAAAYX8ClcPEziCnv5HHRdILKyvGqO', {
            action: 'ellesseTenisPreCadastro'
        }).then(function(token) {
            var recaptchaResponse = document.getElementById('recaptchaResponse');
            recaptchaResponse.value = token;
        });
    });
  }

  verificaCheck("#other",'#otherDetails'); 
  verificaCheck("#other_tipo",'#otherInput'); 
    
  $('input[name="contentTypes"]').on('change', function() {
     verificaCheck("#other_tipo",'#otherInput'); 
  });
  
  $('input[name="alcanceInstagramTiktok"]').on('change', function() {
     verificaCheck("#other",'#otherDetails'); 
  });
  
});


function verificaCheck(check,textIpt){
    otherCheck = $(check).prop('checked');
  
   if (!otherCheck) {
        $(textIpt).val("");
    }

    $(textIpt).prop('disabled', !otherCheck);
  
} 


function submitFormCadastro() {
  
  // Get form values
  email_input = $("#txtEmail").val(); 
  nome_input = $("#txtNome").val(); 
  instagram_input = $("#txtInstagram").val();
  tiktok_input = $("#txtTikTok").val();
  
  // Get checkbox values for content types
  var contentTypes = [];
  $('input[name="contentTypes"]:checked').each(function() {
    contentTypes.push($(this).val());
  });
  
  // Get other content type if specified
  if($("#other_tipo").is(":checked")) {
    contentTypes.push($("#otherInput").val());
  }
  
  // Get followers count
  followers_input = $('input[name="followersInstagramTiktok"]:checked').val();
  
  // Get brand fit
  brandFit_input = $("#brandFit").val();
  
  // Get reach
  alcance_input = $('input[name="alcanceInstagramTiktok"]:checked').val();
  if($('input[name="alcanceInstagramTiktok"]:checked').val() === "Outro") {
    alcance_input = $("#otherDetails").val();
  }
  
  // Get brands content
  conteudoMarcas_input = $("#conteudoMarcas").val();

  email = $("#txtEmail");
  nome = $("#txtNome");
  
  err = 0; 
  
  //validação simples
  var emailFilter=/^.+@.+\..{2,}$/;
  var illegalChars= /[\(\)\<\>\,\;\:\\\/\"\[\]]/  

  if(nome_input==""){
      $(nome).closest(".field").addClass("obrigatorio");
       err++;
  }else{
     $(nome).closest(".field").removeClass("obrigatorio");
  }
  
  if(!(emailFilter.test(email_input))||email_input.match(illegalChars)){
      $(email).closest(".field").addClass("IlegalEmail");
       err++;
  }else{
      $(email).closest(".field").removeClass("IlegalEmail");
  }

  if(err==0){
    if ($('#recaptchaResponse').length > 0) {
          grecaptcha.ready(function() {
            grecaptcha.execute('6LdJC3IaAAAAAAYX8ClcPEziCnv5HHRdILKyvGqO', {
                action: 'ellesseTenisPreCadastro'
            }).then(function(token) {
                var recaptchaResponse = document.getElementById('recaptchaResponse');
                recaptchaResponse.value = token;
            });
        });
    }

    recapchaValue = $('#recaptchaResponse').val();
    
    //Grava os campos 
    Vurl = 'https://algohits.com/loja/cadastro-creator';

    jQuery.ajax({
      type: "POST",
      url: Vurl,
      dataType: "json",
      data: {
          action: 'pre_cadastro',
          txtEmail: email_input,
          txtNome: nome_input,
          txtInstagram: instagram_input,
          txtTikTok: tiktok_input,
          contentTypes: contentTypes,
          followersInstagramTiktok: followers_input,
          brandFit: brandFit_input,
          alcanceInstagramTiktok: alcance_input,
          conteudoMarcas: conteudoMarcas_input,
          respRecapcha: recapchaValue
      },
      xhrFields: {
          withCredentials: true
      },
      success: function(data) {
        if(data){
          if (data.status === "error") {
              htmlMessage = `<div class="errorMsg"><p>Falha ao gravar seus dados, por favor tente 
           novamente mais tarde. Se o erro persistir entre em contato pelo email <a href="mailto:contato@ellessebr.com">contato@ellessebr.com</a></p></div>`;
            $(".returnForm").html(htmlMessage);
            $(".returnForm").removeClass("messageOculta");
          }else{

              /* Submit to confirmation */
            window.location.href="https://ellessebr.com/pages/confirmacao-cadastro";
              
               /*
              $(".formCadastro button").removeClass("loadingBtn")
               htmlMessage = `<div class="sucessoMsg"><p>Muito obrigado pelo interesse no nosso Ellesse Creators Club! As suas informações serão cuidadosamente analisadas pela nossa equipe, tá bom? 

Faremos o contato pelo Instagram da marca para os próximos passos, caso seu perfil seja selecionado. Pode demorar até 30 dias, em média, para a conclusão do processo. 

Agradecemos novamente as informações. </p></div>`;
               $(".returnForm").html(htmlMessage);
               $(".returnForm").removeClass("messageOculta");
            */
          
          
          }
        }else{
           htmlMessage = `<div class="errorMsg"><p>Falha ao gravar seus dados, por favor tente 
           novamente mais tarde. Se o erro persistir entre em contato pelo email <a href="mailto:contato@ellessebr.com">contato@ellessebr.com</a></p></div>`;
            $(".returnForm").html(htmlMessage);
            $(".returnForm").removeClass("messageOculta");
        }

         $("html, body").animate(
    {
        scrollTop: $("#MainContent").offset().top,
    }
    );
        
      },
      beforeSend: function() { 
          $(".formCadastro button").addClass("loadingBtn")
          $(".returnForm").html("");
          $(".returnForm").addClass("messageOculta");
      },
      error: function(){ 
         $(".formCadastro button").removeClass("loadingBtn")
         htmlMessage = `<div class="errorMsg"><p>Falha ao gravar seus dados, por favor tente 
           novamente mais tarde. Se o erro persistir entre em contato pelo email <a href="mailto:contato@ellessebr.com">contato@ellessebr.com</a></p></div>`;
          $(".returnForm").html(htmlMessage);
          $(".returnForm").removeClass("messageOculta");

 $("html, body").animate(
    {
        scrollTop: $("#MainContent").offset().top,
    }
    );
        
      }
      
    });  
  }

 
  
  return false;
}














